module.exports = __webpack_public_path__ + "img/numberEle.c457609a.svg";